import React, { useState, useRef } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button } from "../../core/Buttons";
import { useNavigate } from "react-router-dom";
import { LBCModal } from "../Modals/LBCModal";

export const CartModal = ({ open, setOpen, onClose, cartItems, setCartItems, onOrderNow, data }) => {
  const navigate = useNavigate();

  const [isToastOpen1, setToastOpen1] = React.useState(false);
  
  const [isToastOpen2, setToastOpen2] = React.useState(false);
  const [toastKind2, setToastKind2] = React.useState("");
  const [toastTitle2, setToastTitle2] = React.useState("");
  const [toastDesc2, setToastDesc2] = React.useState("");
  const { bulkSessionId, editItem } = data || {};
  const [showBookingDetails, setShowBookingDetails] = useState(false);

  React.useEffect(() => {
    if (editItem) {
      setShowBookingDetails(false);
    }
  }, [editItem]);
  
  if (!open) return null;

  const updateQuantity = (index, action, targetVariation) => {

    const updatedCartItems = cartItems.map((item, i) => {
      if (i !== index) return item;

      const newItem = { ...item };

      console.log("Price Cart: ", newItem.ncrPrice);

      newItem.quantity = {
        ncr: newItem.quantity?.ncr || 0,
        outsideNCR: newItem.quantity?.outsideNCR || 0
      };

      if (targetVariation === "NCR") {
        if (action === "increment") {
          newItem.quantity.ncr += 1;
        } else if (action === "decrement" && newItem.quantity.ncr > 0) {
          newItem.quantity.ncr -= 1;
        }
      }

      if (targetVariation === "Outside NCR") {
        if (action === "increment") {
          newItem.quantity.outsideNCR += 1;
        } else if (action === "decrement" && newItem.quantity.outsideNCR > 0) {
          newItem.quantity.outsideNCR -= 1;
        }
      }

      return newItem;
    });

    setCartItems(updatedCartItems);
  };

  // const getTotalAmount = () => {
  //   return cartItems.reduce((acc, item) => {
  //     const ncrQty = item.quantity?.ncr ?? 0;
  //     const outQty = item.quantity?.outsideNCR ?? 0;
  //     const ncrPrice = item.price?.ncr ?? 0;
  //     const outPrice = item.price?.outsideNCR ?? 0;

  //     return acc + ncrQty * ncrPrice + outQty * outPrice;
  //   }, 0);
  // };

  const getTotalAmount = () => {
    return cartItems.reduce((acc, item) => {
      const ncrQty = item.quantity?.ncr ?? 0;
      const outQty = item.quantity?.outsideNCR ?? 0;
      const ncrPrice = item.price?.ncr ?? 0;
      const outPrice = item.price?.outsideNCR ?? 0;

      return acc + ncrQty * ncrPrice + outQty * outPrice;
    }, 0);
  };

  const removeItem = (index) => {
    const updatedCartItems = cartItems.filter((_, i) => i !== index);
    setCartItems(updatedCartItems);
  };

  return (
    <>
      <LBCModal
        id="alertModal"
        description={toastDesc2}
        isOpen={isToastOpen2}
        onClose={() => setToastOpen2(false)}
        title={toastTitle2}
        toastKind={toastKind2}
      />
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={() => setOpen(false)}
      >
        <div
          className="absolute top-[280px] right-14 w-[530px] bg-white shadow-md rounded-xl p-5 z-50"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative">
            <div className="border-b pb-3">
              <h2 className="text-lg font-bold">List of orders</h2>
              <p className="text-xs text-gray-500">
                List of packages you've added to your bag, ready for checkout
              </p>
            </div>

            {/* Scrollable List of Items */}
            <div className="max-h-[300px] overflow-y-auto overflow-x-auto mt-4">
              <table className="min-w-full rounded">
                <thead>
                  <tr>
                    <th className="w-70 px-4 py-2 text-center text-sm">Package Type</th>
                    <th className="px-4 py-2 text-center text-sm">Quantity (Within NCR)</th>
                    <th className="px-4 py-2 text-center text-sm">Quantity (Outside NCR)</th>
                    <th className="px-4 py-2 text-center text-sm">Amount</th>
                    <th className="px-4 py-2 text-center text-sm"></th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, index) => {
                    console.log("Cart Product Details: ", item);
                    // Guard clause to skip invalid items
                    if (!item || !item.variation) return null;

                    return (
                      <tr key={index}>
                        <td className="w-64 px-4 py-2 text-center text-sm">
                          <img
                            src={item.image || "/placeholder.jpg"} // fallback image
                            alt="Package"
                            className="w-20 h-20 rounded"
                          />
                          <p className="font-bold text-sm text-center mt-1">{item.name || "No Name"}</p>
                          <p className="text-sm text-center mt-1">25 pcs per bundle</p>
                        </td>

                        <td className="px-4 py-2 text-center text-sm">
                          <div className="flex items-center border border-red-500 rounded-md overflow-hidden w-[75px]">
                            <button
                              className="px-1 border-r border-red-500 text-red-600 font-bold text-xs w-6 h-6 flex items-center justify-center"
                              onClick={() => updateQuantity(index, "decrement", "NCR")}
                            >−</button>
                            <span className="w-6 text-center text-red-600 font-bold text-xs">
                              {item.quantity?.ncr || 0}
                            </span>
                            <button
                              className="px-1 border-l border-red-500 text-red-600 font-bold text-xs w-6 h-6 flex items-center justify-center"
                              onClick={() => updateQuantity(index, "increment", "NCR")}
                            >+</button>
                          </div>
                        </td>

                        <td className="px-4 py-2 text-center text-sm">
                          <div className="flex items-center border border-red-500 rounded-md overflow-hidden w-[75px]">
                            <button
                              className="px-1 border-r border-red-500 text-red-600 font-bold text-xs w-6 h-6 flex items-center justify-center"
                              onClick={() => updateQuantity(index, "decrement", "Outside NCR")}
                            >−</button>
                            <span className="w-6 text-center text-red-600 font-bold text-xs">
                              {item.quantity?.outsideNCR || 0}
                            </span>
                            <button
                              className="px-1 border-l border-red-500 text-red-600 font-bold text-xs w-6 h-6 flex items-center justify-center"
                              onClick={() => updateQuantity(index, "increment", "Outside NCR")}
                            >+</button>
                          </div>
                        </td>

                        <td className="px-4 py-2 text-center text-sm">
                          <p className="font-bold text-sm">
                            ₱{(
                              (item.price?.ncr ?? 0) * (item.quantity?.ncr ?? 0) +
                              (item.price?.outsideNCR ?? 0) * (item.quantity?.outsideNCR ?? 0)
                            ).toFixed(2)}
                          </p>
                        </td>

                        <td className="px-4 py-2 text-center text-sm">
                          <button
                            className="text-red-500 hover:text-red-700 text-sm"
                            onClick={() => removeItem(index)}
                          >
                            <RiDeleteBin6Line className="w-6 h-6 text-[rgb(208,1,73)] cursor-pointer" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="mt-4 flex justify-between items-center font-semibold text-base">
              <Button
                onClick={() => {

                  const hasValidOrder = cartItems.some((item) => {
                    const ncrQty = item.quantity?.ncr ?? 0;
                    const outsideQty = item.quantity?.outsideNCR ?? 0;
                    return ncrQty > 0 || outsideQty > 0;
                  });

                  if (!hasValidOrder) {
                    setToastKind2("info");
                    setToastTitle2("Information");
                    setToastDesc2("Please add at least one item to your cart before ordering.");

                    setTimeout(() => {
                      setToastOpen2(true);
                    }, 200); // show toast

                    setTimeout(() => {
                      setToastOpen2(false);
                    }, 4000);
                    
                    return;
                  }

                  setOpen(false);
                  if (onOrderNow) onOrderNow(cartItems);
                }}
              >
                Order Now
              </Button>
              <div className="flex items-center gap-1 ml-auto">
                <span className="text-sm text-[rgb(208,1,73)]">Total Orders:</span>
                <span className="text-sm font-bold">
                  ₱{getTotalAmount().toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
